<!--
  添加组员
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        type == 1
          ? $t('transfer.addTransferObject')
          : $t('transfer.addTeamMembers')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <van-cell-group>
        <van-field
          v-model="account"
          :label="$t('transfer.theOtherAccount')"
          :placeholder="$t('transfer.eAccountPhone')"
        />
      </van-cell-group>
      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          :loading="btnLoading"
          @click="checkTransferUser"
        >
          {{ $t("transfer.query") }}
        </van-button>
        <p class="tips">
          {{ $t("transfer.transferTips") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {
      account: "",
      btnLoading: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:membersAddFlag", false);
    },
    checkTransferUser() {
      //点击下一步，验证手机号
      let vm = this;
      //判断账号或手机号是否输入
      if (vm.account == "") {
        vm.$toast(vm.$t("transfer.enterTransferAccountOrPhone"));
        return;
      }
      //验证账号或手机号是否正确
      let params = {};
      params.master_account = vm.account;
      vm.btnLoading = true;
      vm.$post("/app/transfer/checkTransferUser", params, {
        alert: true
      }).then(res => {
        console.log("checkTransferUser", res);
        vm.btnLoading = false;
        if (res.code == 0) {
          vm.$emit("update:membersInfoFlag", true);
          vm.$emit("getAmountData", res.data);
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #f4f4f4;
}
/deep/.van-cell-group {
  margin-top: 10px;
}
</style>
